import React, {Component}   from 'react';
import PropTypes            from 'prop-types';

let Quote = require('../Managers/Quote.js');

class CheckboxInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isChecked: false,
        };
    }

    componentWillMount() {
        if (this.props.isDefaultChecked === true) {
            this.setState({ isChecked: true });
        } else if (this.props.isDefaultChecked === false) {
            this.setState({ isChecked: false });
        }
    }

    setUnchecked() {
        this.setState({ isChecked:false });
    }

    /**
     * Push required values back up the tree to the common ancestor dependent on
     * current component state.
     */
    handleClick() {
        if (true === this.state.isChecked) {
            this.setState({ isChecked: false }, () => {
                if (this.props.callbackFunction) {
                    this.props.callbackFunction(this.props.fieldName, false, this);
                }
            });
            Quote.set(this.props.storageKey, false, this.props.source);
        } else {
            this.setState({ isChecked: true }, () => {
                if (this.props.callbackFunction) {
                    this.props.callbackFunction(this.props.fieldName, true, this);
                }
            });
            Quote.set(this.props.storageKey, true, this.props.source);
        }
    }

    render() {
        let FaCheck = require('react-icons/lib/fa/check');
        const isChecked = (!window.uornorb(this.props.overriddenFlag)) ? this.props.overriddenFlag : this.state.isChecked;
        const classSelected = isChecked === true ? 'clickable selected' : 'clickable';
        return (
            <div>
                {this.props.longText ?
                    <div className="checkbox long-text">
                        <div
                            className={classSelected}
                            id={this.props.fieldName}
                            aria-labelledby={this.props.fieldName + '-label'}
                            onClick={this.handleClick.bind(this)}
                        >
                            {isChecked ? (
                                <FaCheck
                                    className="icon"
                                />
                            ) : null}
                        </div>

                        <div dangerouslySetInnerHTML={{__html: this.props.longText}} />
                    </div>
                :
                    <div className="checkbox">
                        {this.props.isLabelFirst ?
                            <label htmlFor={this.props.fieldName} id={this.props.fieldName + '-label'} className="pointer" onClick={this.handleClick.bind(this)}>
                                {this.props.question}
                            </label>
                        : null}

                        <div
                            className={classSelected}
                            id={this.props.fieldName}
                            aria-labelledby={this.props.fieldName + '-label'}
                            onClick={this.handleClick.bind(this)}
                        >
                            {isChecked ? (
                                <FaCheck
                                    className="icon"
                                />
                            ) : null}
                        </div>

                        {!this.props.isLabelFirst ?
                            <label htmlFor={this.props.fieldName} id={this.props.fieldName + '-label'} className="pointer" onClick={this.handleClick.bind(this)} dangerouslySetInnerHTML={{__html: this.props.question}} />
                        : null}

                        {this.props.helpText ?
                            <div>{this.props.helpText}</div>
                        : null}
                    </div>
                }

                <div className="clearfix" />
            </div>
        );
    }
}

CheckboxInput.propTypes = {
    fieldName:          PropTypes.string.isRequired,
    storageKey:         PropTypes.string,
    question:           PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
    longText:           PropTypes.string,
    callbackFunction:   PropTypes.func,
    isLabelFirst:       PropTypes.bool,
    source:             PropTypes.string,
    isDefaultChecked:   PropTypes.bool,
    overriddenFlag:     PropTypes.bool,
    helpText:           PropTypes.string,
};

export default CheckboxInput;


// WEBPACK FOOTER //
// ./src/components/Fields/CheckboxInput.js